import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconPrescribers = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 56.117641 68.418823">
    <path fill={theme.palette.primary.A700} transform="translate(0 0)" d="m52.719 24.413-40.332-23.933c-0.947-0.56159-1.805-0.61375-2.4252-0.24347l-8.9674 5.3562c0.00201-0.0011 0.00405-0.0021 0.006-0.0032-0.61526 0.3639-0.99723 1.1421-1.0004 2.2496v30.075c-0.0061635 2.223 1.4323 4.931 3.314 6.048l40.332 23.932c0.9745 0.5783 1.8541 0.6156 2.4774 0.2099-0.0174 0.0113-0.0345 0.0235-0.0523 0.0342l8.9675-5.3562c0.6118-0.3655 1.0742-1.1426 1.0772-2.2467v-30.075c0.0061-2.2226-1.5144-4.9301-3.3971-6.0473z" />
    <path fill={theme.palette.primary.A100} transform="translate(1 0)" d="m0 5.5926 8.9675-5.3562c0.6198-0.37004 1.4785-0.31806 2.4245 0.24382l-8.9671 5.3562c-0.947-0.5619-1.8052-0.6138-2.4249-0.2438z" />
    <path fill={theme.palette.primary.A400} transform="translate(46.1 60)" d="m8.9675 2.2467-8.9675 5.3562c0.61186-0.3655 1.0742-1.1425 1.0772-2.2467l8.9678-5.3562c-0.003 1.1042-0.4657 1.8812-1.0775 2.2467z" />
    <path fill={theme.palette.primary.A100} transform="translate(47.2 30)" d="m0 5.3562 8.9676-5.3562v30.075l-8.9676 5.356v-30.075z" />
    <path fill={theme.palette.grey[100]} transform="translate(3.4 0)" d="m0 5.3561 8.9675-5.3561 40.332 23.933-8.968 5.356-40.332-23.933z" />
    <path fill={theme.palette.primary.A100} transform="translate(43.8 24)" d="m0 5.3562 8.9675-5.3562c1.8825 1.1172 3.4035 3.8249 3.3975 6.0473l-8.968 5.3557c0.006-2.2219-1.5142-4.9296-3.397-6.0468z" />
    <path fill={theme.palette.primary.A400} transform="translate(0 5)" d="m43.752 24.413c1.8828 1.1173 3.4032 3.8249 3.397 6.0473v30.075c-0.0061 2.2224-1.6194 3.1199-3.5021 2.0025l-40.333-23.932c-1.8817-1.117-3.32-3.825-3.314-6.048v-30.075c0.0062021-2.2226 1.5374-3.1194 3.4192-2.0027l40.333 23.933z" />
    <path fill={theme.palette.grey[100]} transform="translate(9.3 21)" d="m15.731 4.7542v9.1163l7.7191 4.5804v9.462l-7.7452-4.5804v9.1163l-8.037-4.753 0.0251-9.117-7.6931-4.58v-9.4621l7.7443 4.5804v-9.1163l7.9867 4.7542z" />
    <path fill={theme.palette.primary.A400} transform="translate(33.5 10)" d="m0 1.5927 2.6668-1.5927 2.7403 9.8336-2.6668 1.5924-2.7403-9.8333z" />
    <path fill={theme.palette.grey[100]} transform="translate(18.6 1)" d="m0 1.5929 2.6668-1.5929 14.945 8.8684-2.667 1.5926-14.945-8.8681z" />
    <path fill={theme.palette.primary.A100} transform="translate(15.8 3)" d="m17.73 8.8682 2.74 9.8338-2.889-1.715-1.68-6.029-11.304-6.7078-1.7078 4.0194-2.8892-1.7147 2.7848-6.5549 14.945 8.8682z" />
  </SvgIcon>
);

IconPrescribers.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
        A700: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconPrescribers);



// WEBPACK FOOTER //
// ./src/components/icons/IconPrescribers.js